import React from "react";

function BlogComponent() {
    return (
        <div className="text-start">
            Coming soon...
        </div>
    );
}
export default BlogComponent;